import {FC, useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import PlusIcon from '@/assets/images/icon-plus.svg?react';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import Button from '../button';
import {useNewDocumentCreation} from './context';

type Props = {
  ['data-testid']?: string;
  onDialogClose?: () => void;
};

export const NewDocumentCreationDialogButton: FC<Props> = ({onDialogClose, ['data-testid']: dataTestid}) => {
  const {t} = useTranslation();
  const {showDialog} = useNewDocumentCreation();

  const onClick = useCallback(() => {
    showDialog(onDialogClose);
  }, [showDialog, onDialogClose]);

  return (
    <Button
      className="w-full"
      icon={<PlusIcon className="size-5" />}
      label={t('components.new-document-creation.button')}
      trackingKey={WEB_CLICK_TRACKING_KEY.CREATE_NEW_REQUEST}
      onClick={onClick}
      data-testid={dataTestid}
    />
  );
};
